import React from 'react';
import { Box, Stepper, Step, StepLabel, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';

const steps = ['Fill Form', 'Processing', 'Complete'];

const ProgressIndicator = ({ currentStep }) => {
  const getStepIndex = () => {
    switch (currentStep) {
      case 'form':
        return 0;
      case 'processing':
        return 1;
      case 'success':
        return 2;
      default:
        return 0;
    }
  };

  const activeStep = getStepIndex();

  return (
    <Box sx={{ width: '100%', mb: { xs: 3, sm: 4 }, px: { xs: 0, sm: 1 } }}>
      <Stepper 
        activeStep={activeStep} 
        alternativeLabel
        sx={{
          '& .MuiStepLabel-root': {
            '& .MuiStepLabel-label': {
              fontSize: { xs: '0.7rem', sm: '0.75rem', md: '0.875rem' },
            },
          },
        }}
      >
        {steps.map((label, index) => (
          <Step key={label} completed={index < activeStep || (activeStep === 2 && index === 2)}>
            <StepLabel
              StepIconComponent={({ active, completed }) => (
                <Box
                  sx={{
                    width: { xs: 32, sm: 36, md: 40 },
                    height: { xs: 32, sm: 36, md: 40 },
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    bgcolor: completed
                      ? '#19b594'
                      : active
                      ? '#0b74c1'
                      : '#e0e0e0',
                    color: completed || active ? 'white' : '#9e9e9e',
                    transition: 'all 0.3s ease',
                    '& svg': {
                      fontSize: { xs: '1.25rem', sm: '1.5rem', md: '1.75rem' },
                    },
                  }}
                >
                  {completed ? (
                    <CheckCircleIcon />
                  ) : (
                    <RadioButtonUncheckedIcon />
                  )}
                </Box>
              )}
            >
              <Typography 
                variant="caption"
                sx={{
                  fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Text', 'SF Pro Display', 'Segoe UI', 'Helvetica Neue', Arial, sans-serif",
                  fontWeight: 500,
                  color: '#2C3E50',
                  fontSize: { xs: '0.7rem', sm: '0.75rem', md: '0.875rem' },
                }}
              >
                {label}
              </Typography>
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};

export default ProgressIndicator;

